<template>
  <div class="news-share">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'" />
    </div>
    <div class="banner">
      <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661418147365623566.png" alt="">
    </div>
    <div class="content">
        <div class="main-container">
          <div class="tab">
            <template v-for="(item, index) in tabData">
              <div class="item" :class="index === tabIndex ? 'active' : ''" @click="changeType(index)">{{ item.name }}</div>
            </template>
          </div>
          </div>

      <div class="article">
        <template v-for="(item, index) in list">

          <div class="item">
            <div class="title ignor">{{item.title}}</div>
            <div class="info ignor" v-html="item.textContent"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import custTab from '@/components/tab'
import Model from '@/model/news'
export default {
  components: {
    layoutHeader,
    custTab,
  },
  name: 'layout',
  data() {
    return {
      tabIndex: 0,
      tabData:[
        {
          name: '裸眼3D显示屏',
          type: 0
        },
        {
          name: '裸眼3D拼接屏',
          type: 1
        }
      ],
      page: 1,
      totalPage: 0,
      list: []
    }
  },
  created() {
    this.getList()
  },
  mounted() {
  },
  methods: {
    changeType(index) {
      this.tabIndex = index
      this.list = []
      this.page = 1
      this.totalPage = 0
      this.getList()
    },
    async getList() {
      const res = await Model.getCaseShare(this.tabData[this.tabIndex].type, this.page)
      this.totalPage = res.data.totalPage
      this.page++
      this.list = res.data.webCaseShareResps
    }
  }
}
</script>

<style lang="scss" >
  .article .info img{
    max-width: 100%;
  }
</style>
<style lang="scss" scoped>
.news-share {
  background: #111111;
  min-height: 100vh;
  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
    width: 100%;
    box-sizing: border-box;

  }
  .banner {
    img{
      width: 100%;
    }
  }
  .tab {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 24px;
    border-bottom: 1px solid #C4C4C4;
    padding-top: 7px;
    margin-bottom: 28px;
    color: #fff;

    .item {
      margin-right: 100px;
      line-height: 60px;
      cursor: pointer;
    }

    .active {
      font-weight: 500;
      color: #EB6100;
      border-bottom: 7px solid #EB6100;
    }
  }
  .article{
    width: 1420px;
    color: #fff;
    padding-top: 54px;
    .item{
      padding: 37px 148px;
      background: rgba(66,65,65,0.5);
      box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.2);
      border-radius: 8px;
      margin-bottom: 42px;
      .title{
        margin-bottom: 35px;
        font-size: 24px;
        text-align: center;
        //line-height: 28px;
        color: rgba(255,255,255,0.8);
      }
      .info.ignor{
        font-size: 16px;
        line-height: 2rem;
      }
    }
  }
}
</style>
